/**
 * Runs just before main.js, and does one thing: on `/`, it starts downloading the editor.
 *
 * The editor is its own chunk (App.tsx), so a visitor who opens any other page never downloads
 * it. But `/` — where almost every visit lands — would then only ask for it once main.js had
 * downloaded and run: one round trip late, measured 2026-10-08 at +61 ms to first paint of the
 * editor on a fast 4G connection and +213 ms on slow 4G. With this hint the editor downloads
 * alongside main.js, and that cost drops to ~12 ms.
 *
 * Only `/`: every other page would download the editor for nothing and lose what the split
 * saved it. An unknown path still opens the editor, just without the head start.
 *
 * It is a file and not an inline <script> because the page's CSP allows no inline script. The
 * file names are written into index.html at build time (`<meta name="editor-chunks">`).
 */
if (window.location.pathname === '/') {
  const files = document.querySelector('meta[name="editor-chunks"]')?.getAttribute('content')?.split(' ') ?? [];
  files.filter(Boolean).forEach((href) => {
    const link = document.createElement('link');
    if (href.endsWith('.css')) {
      link.rel = 'preload';
      link.as = 'style';
    } else {
      // The chunks run as module scripts (`experiments.outputModule`), and a plain
      // `rel=preload as=script` does not match a module fetch: the file downloaded twice.
      link.rel = 'modulepreload';
    }
    link.href = href;
    document.head.appendChild(link);
  });
}

export {};
